import { DigitalSignSigner } from './digital-sign-signer.model';
import { DigitalSignDocument } from './digital-sign-document.model';

export class DigitalSignNewDossier {
	// ///////////
	// client_dossier_reference_id: string;
	// client_dossier_reference_type: string;
	// client_dossier_type: string;
	// ////////// NOTE: solo per Contract Closing
	signers: DigitalSignSigner[];
	documents: DigitalSignDocument[];
	constructor() {
		this.signers = [];
		this.documents = [];
	}

	addSigner(signer: DigitalSignSigner) {
		this.signers.push(signer);
	}

	addDocument(document: DigitalSignDocument) {
		this.documents.push(document);
	}
}
